import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Alert,
  AuthScreen,
  Button,
  Paper,
  Stack,
  TextInput,
} from '@vipso/shared';
import { useAdminAuth } from '../hooks/useAdminAuth';

export function LoginPage() {
  const { isAuthenticated, login, loginLoading, loginError } = useAdminAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setErrorMessage(null);
    try {
      await login(email, password);
    } catch {
      setErrorMessage('Invalid email or password. Please try again.');
    }
  };

  return (
    <AuthScreen
      title="Master Admin"
      subtitle="Sign in with your system admin account"
    >
      <Paper p="xl" radius="md" withBorder shadow="sm">
        <Stack gap="lg">
          {Boolean(errorMessage || loginError) && (
            <Alert color="red" title="Login failed">
              {errorMessage ?? 'Unable to sign in.'}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.currentTarget.value)}
                required
                autoComplete="username"
              />
              <TextInput
                label="Password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.currentTarget.value)}
                required
                autoComplete="current-password"
              />
              <Button type="submit" loading={loginLoading} fullWidth>
                Sign in
              </Button>
            </Stack>
          </form>
        </Stack>
      </Paper>
    </AuthScreen>
  );
}
